export default __webpack_public_path__ + "static/everett-regular-webfont-14b43151a5c487442a928d6ee1d0dcf6.woff2";